import * as types from '../../../../constants/ActionNameConstants';

// Editor
export const editorRequest = (payload) => {
  return {
    type: types.EDITOR_REQUEST,
    payload,
  };
};

export const editorSuccess = (payload) => ({
  type: types.EDITOR_SUCCESS,
  payload,
});

export const editorFailure = (error) => ({
  type: types.EDITOR_FAILED,
  error,
});

export const resetEditorData = () => {
  return {
    type: types.RESET_EDITOR_DATA,
  };
};

// Vendor Next Transcript
export const vendorNextTranscriptRequest = (payload) => {
  return {
    type: types.VENDOR_NEXT_TRANSCRIPT_REQUEST,
    payload,
  };
};

export const vendorNextTranscriptSuccess = (payload) => ({
  type: types.VENDOR_NEXT_TRANSCRIPT_SUCCESS,
  payload,
});

export const vendorNextTranscriptFailure = (error) => ({
  type: types.VENDOR_NEXT_TRANSCRIPT_FAILED,
  error,
});

export const resetVendorNextTranscript = () => {
  return {
    type: types.RESET_VENDOR_NEXT_TRANSCRIPT,
  };
};

// Editor Proofreader unclaim file
export const proofreaderUnClaimRequest = (payload) => {
  return {
    type: types.PROOFREADER_UNCLAIM_REQUEST,
    payload,
  };
};

export const proofreaderUnClaimSuccess = (payload) => ({
  type: types.PROOFREADER_UNCLAIM_SUCCESS,
  payload,
});

export const proofreaderUnClaimFailure = (error) => ({
  type: types.PROOFREADER_UNCLAIM_FAILED,
  error,
});

// Editor Documents
export const editorDocumentRequest = (payload) => {
  return {
    type: types.EDITOR_DOCUMENTS_REQUEST,
    payload,
  };
};

export const editorDocumentSuccess = (payload) => ({
  type: types.EDITOR_DOCUMENTS_SUCCESS,
  payload,
});

export const editorDocumentFailure = (error) => ({
  type: types.EDITOR_DOCUMENTS_FAILED,
  error,
});

export const resetEditorDocumentData = () => {
  return {
    type: types.RESET_EDITOR_DOCUMENTS_DATA,
  };
};

// Editor Vendor Proof-reader Comment
export const vendorProofreaderCommentRequest = (payload) => {
  return {
    type: types.VENDOR_PROOFREADER_COMMENT_REQUEST,
    payload,
  };
};

export const vendorProofreaderCommentSuccess = (payload) => ({
  type: types.VENDOR_PROOFREADER_COMMENT_SUCCESS,
  payload,
});

export const vendorProofreaderCommentFailure = (error) => ({
  type: types.VENDOR_PROOFREADER_COMMENT_FAILED,
  error,
});

// Editor Vendor resolve proof-reader
export const vendorResolveProofreaderRequest = (payload) => {
  return {
    type: types.VENDOR_RESOLVE_PROOFREADER_REQUEST,
    payload,
  };
};

export const vendorResolveProofreaderSuccess = (payload) => ({
  type: types.VENDOR_RESOLVE_PROOFREADER_SUCCESS,
  payload,
});

export const vendorResolveProofreaderFailure = (error) => ({
  type: types.VENDOR_RESOLVE_PROOFREADER_FAILED,
  error,
});

// Editor Vendor details
export const vendorDetailsRequest = (payload) => {
  return {
    type: types.VENDOR_DETAILS_REQUEST,
    payload,
  };
};

export const vendorDetailsSuccess = (payload) => ({
  type: types.VENDOR_DETAILS_SUCCESS,
  payload,
});

export const vendorDetailsFailure = (error) => ({
  type: types.VENDOR_DETAILS_FAILED,
  error,
});

// Editor Vendor name List
export const vendorNameListRequest = (payload) => {
  return {
    type: types.VENDOR_NAME_LIST_REQUEST,
    payload,
  };
};

export const vendorNameListSuccess = (payload) => ({
  type: types.VENDOR_NAME_LIST_SUCCESS,
  payload,
});

export const vendorNameListFailure = (error) => ({
  type: types.VENDOR_NAME_LIST_FAILED,
  error,
});

// Editor Vendor role submit
export const VendorRoleEditorSubmitRequest = (payload) => {
  return {
    type: types.VENDOR_ROLE_EDITOR_SUBMIT_REQUEST,
    payload,
  };
};

export const VendorRoleEditorSubmitSuccess = (payload) => ({
  type: types.VENDOR_ROLE_EDITOR_SUBMIT_SUCCESS,
  payload,
});

export const VendorRoleEditorSubmitFailure = (error) => ({
  type: types.VENDOR_ROLE_EDITOR_SUBMIT_FAILED,
  error,
});

// Editor Proofreader role submit
export const ProofreaderRoleEditorSubmitRequest = (payload) => {
  return {
    type: types.PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST,
    payload,
  };
};

export const ProofreaderRoleEditorSubmitSuccess = (payload) => ({
  type: types.PROOFREADER_ROLE_EDITOR_SUBMIT_SUCCESS,
  payload,
});

export const ProofreaderRoleEditorSubmitFailure = (error) => ({
  type: types.PROOFREADER_ROLE_EDITOR_SUBMIT_FAILED,
  error,
});

// get all speakers
export const getAllSpeakersRequest = (payload) => {
  return {
    type: types.GET_ALL_SPEAKERS_REQUEST,
    payload,
  };
};

export const getAllSpeakersSuccess = (payload) => ({
  type: types.GET_ALL_SPEAKERS_SUCCESS,
  payload,
});

export const getAllSpeakersFailure = (error) => ({
  type: types.GET_ALL_SPEAKERS_FAILED,
  error,
});

export const resetAllSpeakrsData = () => {
  return {
    type: types.RESET_ALL_SPEAKERS_DATA,
  };
};

// update project speakers
export const updateSpeakersRequest = (payload) => {
  return {
    type: types.UPDATE_SPEAKERS_REQUEST,
    payload,
  };
};

export const updateSpeakersSuccess = (payload) => ({
  type: types.UPDATE_SPEAKERS_SUCCESS,
  payload,
});

export const updateSpeakersFailure = (error) => ({
  type: types.UPDATE_SPEAKERS_FAILED,
  error,
});

// delete project speakers
export const deleteSpeakersRequest = (payload) => {
  return {
    type: types.DELETE_SPEAKERS_REQUEST,
    payload,
  };
};

export const deleteSpeakersSuccess = (payload) => ({
  type: types.DELETE_SPEAKERS_SUCCESS,
  payload,
});

export const deleteSpeakersFailure = (error) => ({
  type: types.DELETE_SPEAKERS_FAILED,
  error,
});

// add project speakers
export const addSpeakersRequest = (payload) => {
  return {
    type: types.ADD_SPEAKERS_REQUEST,
    payload,
  };
};

export const addSpeakersSuccess = (payload) => ({
  type: types.ADD_SPEAKERS_SUCCESS,
  payload,
});

export const addSpeakersFailure = (error) => ({
  type: types.ADD_SPEAKERS_FAILED,
  error,
});

// remove unused project speakers
export const removeUnusedSpeakersRequest = (payload) => {
  return {
    type: types.REMOVE_UNUSED_SPEAKERS_REQUEST,
    payload,
  };
};

export const removeUnusedSpeakersSuccess = (payload) => ({
  type: types.REMOVE_UNUSED_SPEAKERS_SUCCESS,
  payload,
});

export const removeUnusedSpeakersFailure = (error) => ({
  type: types.REMOVE_UNUSED_SPEAKERS_FAILED,
  error,
});

// Check Force Unclaim Request
export const checkForceUnclaimRequest = (payload) => {
  return {
    type: types.CHECK_FORCE_UNCLAIM_REQUEST,
    payload,
  };
};

export const checkForceUnclaimSuccess = (payload) => ({
  type: types.CHECK_FORCE_UNCLAIM_SUCCESS,
  payload,
});

export const checkForceUnclaimFailure = (error) => ({
  type: types.CHECK_FORCE_UNCLAIM_FAILED,
  error,
});

export const checkForceUnclaimReset = () => {
  return {
    type: types.CHECK_FORCE_UNCLAIM_RESET,
  };
};

export const AddNewSpeaker = (speakerData) => ({
  type: types.ADD_NEW_SPEAKER,
  payload: speakerData,
});

export const saveSlateDataRequest = (payload) => ({
  type: types.SAVE_SLATE_DATA_REQUEST,
  payload,
});

export const saveSlateDataSuccess = (data) => ({
  type: types.SAVE_SLATE_DATA_SUCCESS,
  payload: { data },
});

export const saveSlateDataFailure = (error) => ({
  type: types.SAVE_SLATE_DATA_FAILURE,

  payload: { error },
});

export const vendorCompleteParagraphRequest = (payload) => {
  return {
    type: types.TRANSCRIPT_COMPLETE_PARAGRAPH_REQUEST,
    payload,
  };
};

export const vendorSaveTranscriptParagraphFileSuccess = (payload) => ({
  type: types.VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_SUCCESS,
  payload,
});

export const vendorSaveTranscriptParagraphFileFailure = (error) => ({
  type: types.VENDOR_SAVE_TRANSCRIPT_PARAGRAPH_FILE_FAILED,
  error,
});
